"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiProductRepo = createApiProductRepo;
const HTTPClient_1 = require("../../../common/api/HTTPClient");
const http_helpers_1 = require("../../../common/api/http-helpers");
const ItemList_1 = require("../../../common/models/ItemList");
const ProductMapper_1 = require("./mappers/ProductMapper");
const getApiUrl_1 = require("../../../common/api/utils/getApiUrl");
function createApiProductRepo() {
    return {
        getAll,
        getById,
        deleteProduct,
        createProduct,
        updateProduct,
    };
}
async function getAll(page = 1, pageSize = 10, productName = '') {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/products`),
            params: {
                page,
                pageSize,
                productName,
            },
        });
        const productList = {
            items: res.products.map(ProductMapper_1.mapToDomainProduct),
            pagination: res.pagination,
        };
        (0, http_helpers_1.sendSuccessStatus)();
        return productList;
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return (0, ItemList_1.emptyList)();
    }
}
async function getById(id) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/products/${id}`),
        });
        const product = (0, ProductMapper_1.mapToDomainProduct)(res);
        (0, http_helpers_1.sendSuccessStatus)();
        return product;
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return null;
    }
}
async function deleteProduct(id) {
    try {
        const res = await HTTPClient_1.HTTPClient.delete({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/products/${id}`),
        });
        (0, http_helpers_1.sendSuccessStatus)();
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        throw error;
    }
}
async function createProduct(product) {
    try {
        await HTTPClient_1.HTTPClient.post({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/products`),
            body: product,
            type: 'json',
        });
        (0, http_helpers_1.sendSuccessStatus)();
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        throw error;
    }
}
async function updateProduct(product) {
    try {
        await HTTPClient_1.HTTPClient.put({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/products/${product.micronProductId}`),
            body: product,
            type: 'json',
        });
        (0, http_helpers_1.sendSuccessStatus)();
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        throw error;
    }
}
